import { render, staticRenderFns } from "./ui-logout.vue?vue&type=template&id=10ba0996&"
import script from "./ui-logout.vue?vue&type=script&lang=ts&"
export * from "./ui-logout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports